const Config: any = {
  BaseUrlDev: "https://api.lujgroup.com/",
};
export default Config;
